import { render } from "./GastroPanelTestSelection.vue?vue&type=template&id=eaac2bb4"
import script from "./GastroPanelTestSelection.vue?vue&type=script&lang=js"
export * from "./GastroPanelTestSelection.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/testInfo/testSelection/GastroPanelTestSelection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eaac2bb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eaac2bb4', __exports__)) {
    console.log('reload')
    api.reload('eaac2bb4', __exports__)
  }
  
  module.hot.accept("./GastroPanelTestSelection.vue?vue&type=template&id=eaac2bb4", () => {
    console.log('re-render')
    api.rerender('eaac2bb4', render)
  })

}


export default __exports__